import { Box } from 'roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem';

export const FilterContainer = styled(Box)`
  border-radius: ${themeGet('radii.default')};
  background: white;
  border: 1px solid ${themeGet('colors.greys.alto')};
  ${mediaQuery.minWidth.sm} {
    border-radius: 0;
    border: none;
    border-bottom: none;
    background: none;
  }
`;
